export default "__VITE_ASSET__Bg9$VjRT__"